import React, { useEffect, useState } from "react";
import "../../style.css";
import { Box, Typography, Chip, Tooltip, IconButton } from "@mui/material";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useProjectApiClient } from "../Services/api/projectService"
import { Pagination, PaginationItem } from "@mui/material";
import { useLoader } from "../../pages/LoaderContext";
// import { ContentCopy, Edit } from "@mui/icons-material";
import CopyProjectModal from './CopyProjectModal';
import { useAppContext } from '../../hooks/context/AppContext';
import "./gridlist.css";
import { ToastContainer } from "react-toastify";
import { ContentCopy, DeleteOutline, ModeEditOutlineOutlined, FileUploadOutlined, CloudDownloadOutlined, Edit, FileDownloadOutlined } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import { GridDeleteIcon } from "@mui/x-data-grid";
import { successToast } from "../utils/toast";
import alertIcon from "../../assets/images/alert.png";
import bulbIcon from "../../assets/images/bulb-light-icon.svg";
import { projectVersion } from "config/navConfig";


interface Project {
  project_key: string;
  Project_Id: string;
  bu: string;
  name: string;
  sclead: string;
  country: string;
  category: string;
  subCategory: string;
  brand: string;
  Launch_Year: string;
  launch_Month: string;
  launch_Week: string;
  ProjectStatus: string;
  bigBet: string;
  Bigbetvalue: string;
  uploadPic: string;
  Risk: string;
  comment: string;
  totalProjects: number;
  issaved: number;
  upload_pic?: string;
  country_key: string;
  category_Key: string;
  subcategory_key: string;
  brand_key: string;
  buid: number;
  sclead_key: number;
  risk_key: number;
  big_bet: number;
  Time_Key: number;
  project_name?: string;
  L2_Unilever_Cluster_Desc?: string;
  projectName?: string;
  project_id?: string;
  imageName?: string;
  // optional attributes array used in the table mapping (e.g. milestone attributes)
  project_attributes?: any[];
}

interface ProjectsListProps {
  selectedFilter: string;
  filters: Record<string, string>;
}

interface Permissions {
  CanRead: boolean;
  CanView: boolean;
  CanCopy: boolean;
  CanDelete: boolean;
  CanEdit: boolean;
  CanCreate: boolean;
  CanSoftDelete: boolean;
}

interface User {
  Email: string;
  FullName: string;
  Role: string;
  module: string;
  permissions: Permissions;
}

export default function ProjectsList({ selectedFilter, filters }: ProjectsListProps) {
  const { getAllProjects, removeProject } = useProjectApiClient()
  const { userData } = useAppContext();
  const [user, setUser] = useState<User | null>(null);
  const [projects, setProjects] = useState<Project[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [totalProjects, setTotalProjects] = useState(0);
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState<Project | null>(null);
  localStorage.removeItem("ProjectDetails"); // Clear ProjectDetails from localStorage
  localStorage.removeItem("project_key"); // Clear project_key from localStorage
  useEffect(() => {
    if (userData) {
      // @ts-ignore
      setUser(userData)
    }
  }, [userData]);

  const fetchProjects = async (filter = selectedFilter, advancedFilters = filters) => {
    setLoading(true);
    try {
      let issaved = filter === "saved" ? 1 : filter === "draft" ? 0 : undefined;
      console.log(" Fetching projects with:", { filter, issaved, advancedFilters });

      const data = await getAllProjects(page + 1, rowsPerPage, issaved, advancedFilters);
      // @ts-ignore
      setProjects(data.projects); setTotalProjects(data.totalProjects);
    } catch (error) {
      console.error("Failed to fetch projects:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects(selectedFilter, filters);
  }, [page, rowsPerPage, selectedFilter, filters]);

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: 'rgb(210 225 255)',
        fontWeight: 'bold',
        fontSize: '12px',
      },
    },
    headCells: {
      style: {
        justifyContent: 'flex-start' as const,
        textAlign: 'start' as const,
        paddingLeft: '8px',
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        fontSize: '12px',
        paddingLeft: '8px',
        paddingRight: '8px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'start' as const,
      },
    },
  };

  const handleremoveProject = async () => {
    if (!projectToDelete) return;

    try {
      setLoading(true);
      const res = await removeProject(projectToDelete.project_id);
      setIsDeleteDialogOpen(false);
      setProjectToDelete(null);
      fetchProjects(); // Refresh the project list 
      successToast(res.message);
      setLoading(false);
    } catch (error) {
      console.error("Failed to delete project:", error);
      setLoading(false);
    }
  };
  const columns = [
    {
      name: '',
      width: '20px',
      selector: (row: any) => row.sNo,
      sortable: true,
      cell: (row: any) => (
        <Tooltip title={row.issaved ? 'Saved' : 'Draft'} placement="top" arrow>
          <span
            style={{
              display: 'block',
              width: '100%',
              height: '100%',
              backgroundColor: row.issaved ? '#16e17f' : '#f9a630', // green for saved, red for draft
            }}
          />
        </Tooltip>
      ),
    },
    {
      name: 'S.No',
      width: '60px',
      selector: (row: any) => row.sNo,
      sortable: true,
      cell: (row: any) => (
        <Tooltip title={row.sNo} placement="top" arrow>
          <span>{row.sNo}</span>
        </Tooltip>
      ),
    },
    {
      name: 'Project Name',
      width: '120px',
      selector: (row: any) => row.projectName,
      cell: (row: any) => (
        <Tooltip title={row.projectName} placement="top" arrow>
          <Typography
            variant="body2"
            sx={{
              fontSize: '13px',
              color: "blue",
              cursor: "pointer",
              "&:hover": { color: "darkblue" },
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            
            onClick={() => navigate(`${projectVersion}/project/project-info/${row.project_id}/${row.project_key}`)}
          >
            {row.projectName}
          </Typography>
        </Tooltip>
      ),
      sortable: true,

    },
    {
      name: 'SC Lead',
      selector: (row: any) => row.scLead,
      cell: (row: any) => (
        <Tooltip title={row.scLead} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.scLead}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'BU',
      selector: (row: any) => row.bu,
      cell: (row: any) => (
        <Tooltip title={row.bu} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.bu}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Country',
      selector: (row: any) => row.country,
      cell: (row: any) => (
        <Tooltip title={row.country} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.country}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Category',
      selector: (row: any) => row.category,
      cell: (row: any) => (
        <Tooltip title={row.category} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.category}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Brand',
      selector: (row: any) => row.brand,
      cell: (row: any) => (
        <Tooltip title={row.brand} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.brand}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Master Brand',
      selector: (row: any) => row.subCategory,
      cell: (row: any) => (
        <Tooltip title={row.subCategory} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.subCategory}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Launch Year',
      width: '120px',
      selector: (row: any) => row.LaunchYear,
      cell: (row: any) => (
        <Tooltip title={row.LaunchYear} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.LaunchYear}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Project Status',
      cell: (row: any) => (
        <Tooltip title={row.projectStatus === "Active" ? "Active" : "In-active"} placement="top" arrow>
          <span>{row.projectStatus === "Active" ? "Active" : "In-active"}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Big Bet',
      width: '80px',
      selector: (row: any) => row.bigBet,
      cell: (row: any) => (
        <Tooltip title={row.bigBet} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.bigBet}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Risk',
      width: '80px',
      cell: (row: any) => {
        let riskClass = "";
        switch (row.risk?.toLowerCase()) {
          case "high":
            riskClass = "high";
            break;
          case "medium":
            riskClass = "medium";
            break;
          case "low":
            riskClass = "low";
            break;
        }
        return (
          <Tooltip title={row.risk} placement="top" arrow>
            <span className={`risk ${riskClass}`}>{row.risk}</span>
          </Tooltip>
        );
      },
      sortable: true,
    },
    {
      name: 'Actions',
      width: '200px',
      cell: (row: any) => (
        <>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Tooltip title="Edit">
              <IconButton
                disabled={user?.permissions?.CanEdit === true ? false : true}
                size="small"
                onClick={() => navigate(`${projectVersion}/project/project-info/${row.project_id}/${row.project_key}`)}
              >
                <ModeEditOutlineOutlined fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Upload">
              <IconButton 
                disabled={user?.permissions?.CanEdit === true ? false : true}
                size="small" onClick={() => navigate(`${projectVersion}/project/project-info/${row.Project_Id}/${row.project_key}?isUpload=true&moduleId=${1}`)}>
                <FileUploadOutlined fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Download">
              <IconButton 
                disabled={user?.permissions?.CanEdit === true ? false : true}
                size="small" onClick={() => window.open(`${process.env.REACT_APP_BACKEND_V2}/projects/export/${row.project_key}`, "_blank")}>
              <FileDownloadOutlined fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Copy">
              <IconButton 
                disabled={user?.permissions?.CanCopy === true ? false : true}
                size="small"
                onClick={() => {
                  setSelectedProject(row);
                  setIsCopyModalOpen(true);
                }}
              >
                <ContentCopy fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                disabled={user?.permissions?.CanSoftDelete === true ? false : true}
                size="small"
                onClick={() => {
                setProjectToDelete(row);
                setIsDeleteDialogOpen(true);
              }}
              >
                <DeleteOutline fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>

          {/* <Tooltip title="Edit" placement="top" arrow>
            <Chip
              disabled={user?.permissions?.CanEdit === true ? false : true}
              sx={{
                backgroundColor: "#00D5C3",
                color: "#fff",
                cursor: "pointer",
                marginRight: 0.5,
                paddingX: 1,
                minWidth: 60,
                height: 28,
                fontSize: 12,
                "& .MuiChip-label": { display: "flex", alignItems: "center", gap: 0.2 },
                "&:hover": { backgroundColor: "#00BFA5" },
              }}
              label={
                <Box display="flex" alignItems="center" gap={0.3}>
                  <Edit sx={{ fontSize: 12 }} />
                  Edit
                </Box>
              }
              onClick={() => navigate(`${projectVersion}/project/project-info/${row.project_id}/${row.project_key}`)}
            />
          </Tooltip> */}


          {/* <Tooltip title="Copy" placement="top" arrow>
            <Chip
              disabled={user?.permissions?.CanCopy === true ? false : true}
              sx={{
                backgroundColor: "#00D5C3",
                color: "#fff",
                cursor: "pointer",
                marginLeft: 0.5,
                paddingX: 1,
                minWidth: 60,
                height: 28,
                fontSize: 12,
                "& .MuiChip-label": { display: "flex", alignItems: "center", gap: 0.2 },
                "&:hover": { backgroundColor: "#00BFA5" },
              }}
              label={
                <Box display="flex" alignItems="center" gap={0.3}>
                  <ContentCopy sx={{ fontSize: 12 }} />
                  Copy
                </Box>
              }
              onClick={() => {
                setSelectedProject(row);
                setIsCopyModalOpen(true);
              }}
            />
          </Tooltip> */}
          {/* Delete Button */}
          {/* <Tooltip title="Delete" placement="top" arrow>
            <Chip
              disabled={!user?.permissions?.CanSoftDelete}
              sx={{
                backgroundColor: "#f44336", // lighter red
                color: "#ffffff",            // white text
                cursor: "pointer",
                marginLeft: 0.5,
                paddingX: 1,
                minWidth: 60,
                height: 28,
                fontSize: 12,
                "& .MuiChip-label": {
                  display: "flex",
                  alignItems: "center",
                  gap: 0.2,
                },
                "&:hover": {
                  backgroundColor: "#e53935", // slightly darker on hover
                },
              }}
              label={
                <Box display="flex" alignItems="center" gap={0.3}>
                  <GridDeleteIcon sx={{ fontSize: 14, color: "#ffffff" }} />
                  Delete
                </Box>
              }
              onClick={() => {
                setProjectToDelete(row);
                setIsDeleteDialogOpen(true);
              }}
            />
          </Tooltip> */}

        </>
      ),
    },
  ];

  return (
    <>
      <ToastContainer />
      <div className="data-grid-table">
        <div className="data-grid-table" style={{ overflowX: "auto", padding: "20px", backgroundColor: "#fff ", margin: "0px 2%" }}>
          <Box
            className="boxBoder-Table"
            sx={{
              padding: "0px",
              backgroundColor: "white",
              fontSize: "12px",
            }}
          >
            <DataTable
              columns={columns}
              data={projects.map((project, index) => {
              const milestoneAttr = project.project_attributes?.find((attr: any) => attr.toSaveMileStone);

              return {
                issaved: project.issaved,
                project_key: project.project_key,
                project_id: project.Project_Id,
                sNo: index + 1 + page * rowsPerPage,
                projectName: project.name,
                scLead: project.sclead,
                bu: project.L2_Unilever_Cluster_Desc,
                country: milestoneAttr?.country || project.country,
                category: project.category,
                brand: milestoneAttr?.brand || project.brand,
                subCategory: project.subCategory,
                LaunchYear: milestoneAttr?.Launch_Year || project.Launch_Year,
                projectStatus: project.ProjectStatus,
                bigBet: project.Bigbetvalue,
                risk: project.Risk,
                imageName: project.upload_pic,
                category_Key: project.category_Key,
                subcategory_key: project.subcategory_key,
                brand_key: project.brand_key,
              };
            })}
              customStyles={customStyles}
              paginationServer
              paginationTotalRows={totalProjects}
              paginationPerPage={rowsPerPage}
              paginationComponentOptions={{ noRowsPerPage: true }}
              onChangePage={(newPage) => setPage(newPage - 1)}
              responsive
              noDataComponent={
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <Typography variant="h6" color="textSecondary">
                    No Projects Found
                  </Typography>
                </Box>
              }
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                padding: "10px",
                width: "100%",
                gap: "20px"
              }}
            >
              <Typography sx={{ fontSize: 12, color: "blue", fontWeight: 600 }}>
                Total Projects
                <Chip label={totalProjects} color="primary" sx={{ marginLeft: 1 }} />
              </Typography>
              <Pagination
                count={Math.ceil(totalProjects / rowsPerPage)}
                page={page + 1}
                onChange={(_, newPage) => setPage(newPage - 1)}
                siblingCount={1}
                boundaryCount={1}
                showFirstButton
                showLastButton
                renderItem={(item) => <PaginationItem {...item} />}
              />
            </Box>
          </Box>
        </div>
      </div>
      {selectedProject && (
        <CopyProjectModal
          open={isCopyModalOpen}
          onRefresh={fetchProjects}
          onClose={() => setIsCopyModalOpen(false)}
          projectName={selectedProject?.projectName ?? ""}
          projectId={selectedProject?.project_id ?? ""}
          projectKey={selectedProject?.project_key ?? ""}
          existingCountry={selectedProject?.country ?? ""}
          imageName={selectedProject.imageName}
          category_Key={selectedProject.category_Key ?? ""}
          subcategory_key={selectedProject.subcategory_key ?? ""}
          brand_key={selectedProject.brand_key ?? ''}
        />
      )}
      <Dialog
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
      >
        <div className="delete-modal">
          <DialogTitle>
            <h3 className="modal-title">Delete Confirmation</h3>
          </DialogTitle>
          <hr></hr>

          <DialogContent>
            <div className="save-card-wapper">

              <div className="alert-icon-wp">
                <img src={alertIcon} alt="" />
              </div>
              <h2 className="title-save-frm"></h2>
              <div className="txt-flex--mt">
                <span className="bulb-txt"><img src={bulbIcon} alt="" /></span>
                <p> Are you sure you want to delete this item? It will no longer appear in project list.</p>
              </div>
            </div>
          </DialogContent>

          <DialogActions>
            <Button className="btn-cancel" onClick={() => setIsDeleteDialogOpen(false)} color="primary">
              Cancel
            </Button>
            <Button className="btn-delete" onClick={handleremoveProject} color="error" variant="contained">
              Delete
            </Button>
          </DialogActions>
        </div>
      </Dialog>

    </>
  );
}